<template>
  <div class="main-bg">
    <v-img :src="mainBg" alt="main-bg" class="full-height-image"></v-img>
  </div>
</template>

<script>
export default {
    name: "MainAuth",
    data() {
        return {
            mainBg: require("../../../assets/Images/Auth/login-background.png"),
        }
    }
}
</script>

<style scoped>
.main-bg {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.full-height-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: pixelated;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

/* Additional quality improvements */
.full-height-image img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
</style>